import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  chipContainer: {
    display: 'flex',
    // justifyContent: 'space-around',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  chipsTitle: {
    fontWeight: 400,
    fontSize: 15.5,
    color: '#8C949E',
    // opacity: 0.7,
  },
}));

export default useStyles;
